// Global cart drawer controller
let globalOpenCart: (() => void) | null = null;

export const setGlobalCartOpener = (opener: () => void) => {
  globalOpenCart = opener;
};

export const openCartGlobally = () => {
  if (globalOpenCart) {
    globalOpenCart();
  }
};